<template>
  <div class="d-flex flex-column justify-content-start  register" id="registerpage">
    <b-button variant="white" class="back-button" @click="$router.go(-1)">
      <i class="ri-arrow-left-line"></i>
      Login
    </b-button>
    <div class="form" style="position: relative">
      <img class="logo" :src="require('../../assets/images/logo-brand.png')" />
      <h6 class="mb-5">Pendaftaran Perusahaan</h6>
      <div class="stepper my-10 d-flex flex-row align-items-center">
        <div class="stepper-number" :class="{ active: step === 1 }">1</div>
        <span :class="{ active: step === 1 }">Perusahaan</span>
        <div class="stepper-separator" />
        <div class="stepper-number" :class="{ active: step === 2 }">2</div>
        <span :class="{ active: step === 2 }">Penanggung Jawab</span>
      </div>
      <div class="form-wrapper">
        <div class="step-1" :class="{ active: step == 1 }">
          <form @submit="loginState($event)" class="form-1">
            <b-form-group label="Nama Perusahaan" label-class="required">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="ri-building-4-fill"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  placeholder="PT. ReadyMix"
                  v-model="formRegister.corporate.name"
                  required
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Kota atau Kabupaten" label-class="required">
              <v-select
                v-model="formRegister.corporate.city_id"
                class="v-city"
                :options="cities"
                @search="getCity"
                @open="getInitialCity"
                placeholder="- Pilih Kota atau Kabupaten"
                required
              />
            </b-form-group>

            <b-form-group label="Detail Alamat">
              <b-input-group>
                <b-textarea
                  type="textarea"
                  rows="4"
                  placeholder="Tuliskan nama blok, nama jalan atau penanda lain"
                  v-model="formRegister.corporate.address"
                >
                </b-textarea>
              </b-input-group>
            </b-form-group>

            <b-form-group>
              <b-button variant="primary-light" type="submit">
                <i class="ri-arrow-right-s-line" />
                Lanjutkan
              </b-button>
            </b-form-group>
          </form>
        </div>

        <div class="step-2" :class="{ active: step === 2 }">
          <form @submit="loginState($event)" class="form-2">
            <b-form-group label="Nama Penanggung Jawab" label-class="required">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="ri-user-2-fill"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  placeholder=""
                  v-model="formRegister.pic.name"
                  required
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group label="No. Telepon" label-class="required">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="ri-phone-fill"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  placeholder=""
                  v-model="formRegister.pic.phone"
                  required
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Username" label-class="required">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="ri-user-2-fill"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="text"
                  placeholder=""
                  v-model="formRegister.pic.username"
                  required
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Email" label-class="required">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="ri-mail-fill"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  type="email"
                  placeholder=""
                  v-model="formRegister.pic.email"
                  required
                >
                </b-form-input>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Password" label-class="required">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="ri-lock-password-fill"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  :type="showPassword ? 'text' : 'password'"
                  placeholder=""
                  v-model="formRegister.pic.password"
                  required
                >
                </b-form-input>

                <template #append>
                <b-button
                  @click="showPassword = !showPassword"
                  variant="light"
                  size="sm"
                >
                  <i
                    :class="!showPassword ? 'ri-eye-off-line' : 'ri-eye-line'"
                  ></i>
                </b-button>
              </template>
              </b-input-group>
            </b-form-group>

            <b-form-group label="Ulangi Password" label-class="required">
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="ri-lock-password-fill"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input
                  :type="showConfirmPassword ? 'text' : 'password'"
                  placeholder=""
                  v-model="formRegister.pic.retype_password"
                  required
                >
                </b-form-input>
                <template #append>
                <b-button
                  @click="showConfirmPassword = !showConfirmPassword"
                  variant="light"
                  size="sm"
                >
                  <i
                    :class="!showConfirmPassword ? 'ri-eye-off-line' : 'ri-eye-line'"
                  ></i>
                </b-button>
              </template>
              </b-input-group>
            </b-form-group>
            <b-form-group>
              <b-button variant="outline-primary" class="mr-3" @click="test">
                <i class="ri-arrow-left-s-line" />
              </b-button>
              <b-button variant="primary" type="submit" :disabled="isLoading">
                <i class="ri-login-circle-line" />
                Daftarkan Perusahaan
              </b-button>
            </b-form-group>
          </form>
        </div>
      </div>
    </div>
    <img
      :src="require('../../assets/images/frame-login.png')"
      class="register-frame"
    />
    <!-- <img :src="require('../../assets/images/frame-login-1.png')" class="register-frame-1" /> -->
  </div>
</template>
<script>
import "./register.scss";
export default {
  name: "register-page",
  data() {
    return {
      state: "signin",
      username: "admin",
      password: "semarang",
      errorLogin: null,
      forgetEmail: null,
      showResendEmail: false,
      tmp_user: null,
      resendWaiting: 0,
      isLoading: false,
      step: 1,
      cities: [],
      showPassword: false,
      showConfirmPassword: false,

      formRegister: {
        corporate: {
          name: "",
          city_id: null,
          address: ""
        },
        pic: {
          username: "",
          name: "",
          phone: "",
          email: "",
          password: "",
          retype_password: ""
        }
      }
    };
  },
  methods: {

    scrollToTop() {
      this.$nextTick(() => {
        this.$refs.registerpage.scrollTop = 0
      });
    },
    test() {
      this.step = this.step === 1 ? 2 : 1;
      this.scrollToTop()
    },

    getInitialCity() {
      this.$_api
        .get("/lookup/city")
        .then(response => {
          let _data = [];
          for (const _city of response.data.data) {
            _data.push({
              label: _city.name,
              value: _city.id
            });
          }

          this.cities = _data;

          // loading(false);
        })
        .catch(err => {
          // loading(false);
        });
    },

    getCity(search, loading) {
      loading(true);
      this.$_api
        .get("/lookup/city", { search: search })
        .then(response => {
          let _data = [];
          for (const _city of response.data.data) {
            _data.push({
              label: _city.name,
              value: _city.id
            });
          }

          this.cities = _data;

          loading(false);
        })
        .catch(err => {
          loading(false);
        });
    },
    goToRegister() {
      this.$router.push({ path: "/register" });
    },
    loginState(e) {
      e.preventDefault();

      if (this.step === 1) {
        this.step = 2;
        this.scrollToTop()
        return;
      }

      this.isLoading = true;

      let payload = JSON.parse(JSON.stringify(this.formRegister));
      payload.corporate.city_id = payload.corporate.city_id.value;

      this.$_api
        .post("/register/corporate", payload)
        .then(response => {
          this.isLoading = false;
          this.$_alert.success(
            "Berhasil mendaftarkan perusahaan, login untuk melanjutkan"
          );
          this.$router.push({ path: "/login" });
        })
        .catch(err => {
          this.isLoading = false;
          this.$_alert.error(err);
        });
      //   if (this.username && this.password) {

      //     this.isLoading = true
      //     let data = { username: this.username, password: this.password }
      //     this.$_api.post('/login', data).then(res => {
      //       this.isLoading = false
      //       if (res.data) this.saveProfile(res.data)
      //       else this.actionUser(res.data_user_before_login, res.message)
      //     }).catch((err) => {
      //       this.isLoading = false
      //       this.errorLogin = err.data.message
      //     })
      //     this.errorLogin = null
      //   } else {
      //     this.errorLogin = 'Username & Password harus diisi'
      //   }
    },
    actionUser(data, message) {
      this.tmp_user = data;
      if (data.status_code === "email_unverified") {
        this.showResendEmail = true;
        this.errorLogin = message;
      } else if (data.status_code === "email_verified") {
        this.$router.push({ name: "waiting-apps", params: { user: data } });
      }
    },
    resendVerification() {
      if (this.resendWaiting === 0) {
        this.$_api
          .post("/request_email_verification", this.tmp_user)
          .then(res => {
            this.resendWaiting = 60;
            this.setWaiting();
          })
          .catch(err => {
            this.errorLogin = err.data.message;
          });
      }
    },
    setWaiting() {
      setTimeout(() => {
        if (this.resendWaiting > 0) {
          this.resendWaiting--;
          this.$nextTick();
          this.setWaiting();
        }
      }, 1000);
    },
    async saveProfile(e) {
      this.$store.commit("set", ["profile", e.profile, true]);
      this.$store.commit("set", ["_token", e.token, true]);
      this.$store.commit("set", ["permission", e.permissions, true]);
      await this.$store.dispatch("setModule");
      this.$router.push({ name: "main-module" });
    },
    forgetPassword() {
      this.$_api
        .post("/request_forgot_password", { email: this.forgetEmail })
        .then(res => {
          this.forgetEmail = null;
          this.state = "forgot-success";
        })
        .catch(err => {
          this.errorLogin = err.data.message;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/default-page/register/register.vue